import React, {useContext} from 'react';
import useScrollToSection from '../hooks/useScrollToSection';
import { NavLink, Navigate } from 'react-router-dom';
import RegistrationForm from '../components/RegistrationForm';
import Modal from '../components/Modal';
import useModal from '../hooks/useModal';

import { AuthContext } from "../context/authContext.js";

const BecomeTutorPage = () => {
  
    const {currentUser} = useContext(AuthContext);  
    const handleRegisterTutorClick = useScrollToSection('register-tutor');
    const { modalVisible, modalContent, handleFormSuccess, handleFormFailure, handleCloseModal } = useModal();
    
    if(currentUser) return <Navigate to="/dashboard"/>


    return (
        <main id="main">
        {modalVisible && <Modal {...modalContent} onClose={handleCloseModal} />}
        
        <section id="hero" className="hero d-flex align-items-center section-bg-w">
          <div className="container">
            <div className="row justify-content-between gy-5">
              <div className="col-lg-5 order-1 order-lg-2 d-flex flex-column justify-content-center align-items-center align-items-lg-start text-center text-lg-start">
                <h2 data-aos="fade-up">Poveži se lako sa<br/>novim studentima</h2>
                <p data-aos="fade-up" data-aos-delay="100">Casovi.me vam tokom cijele školske godine nudi više posla putem uspostavljanja novih veza sa zainteresovanim učenicima svih uzrasta!
                </p>
                <div className="d-flex " data-aos="fade-up" data-aos-delay="200">
                  <NavLink to='#register-tutor' onClick={handleRegisterTutorClick} className="hero-a-btn">Prijavite se</NavLink>
                </div>
              </div>
              <div className="col-lg-6 order-2 order-lg-1 text-center text-lg-start">
                <img src="/assets/images/learning.webp" className="img-fluid " alt="" data-aos="zoom-out" data-aos-delay="300"/>
              </div>
            </div>
          </div>
        </section>
        
        <section id="why-us" className="why-us section-bg">
          <div className="container" data-aos="fade-up">
    
            <div className="row gy-4">
    
              <div className="col-lg-12 d-flex align-items-center">
                <div className="row gy-4">
    
                  <div className="col-xl-4" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center tutors-help">
                      <i className="icofont-ui-clock"></i>
                      <h4 className="smaller-font">Birate kada i koliko radite</h4>
                      <p>Kreirajte sopstveni raspored i sami odredite kada ste dostupni za privatne časove. Nakon toga, samo čekate poruke od učenika koje će pristizati putem našeg interaktivnog chata i putem e-maila.</p>
                    </div>
                  </div>
    
                  <div className="col-xl-4" data-aos="fade-up" data-aos-delay="300">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center tutors-help">
                      <i className="icofont-megaphone"></i>
                      <h4 className="smaller-font">Mi vas promovišemo i reklamiramo</h4>
                      <p>Na vama je samo da se učlanite i popunite profil a mi ćemo se potruditi da budete viđeni što većem broju potencijalnih učenika.</p>
                    </div>
                  </div>
    
                  <div className="col-xl-4" data-aos="fade-up" data-aos-delay="400">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center tutors-help">
                      <i className="icofont-live-support"></i>
                      <h4 className="smaller-font">Pružamo podršku kada god je potrebna</h4>
                      <p>Tu smo za vas! Za bilo kakva pitanja i nedoumice stojimo vam na raspolaganju.</p>
                    </div>
                  </div>
    
                </div>
              </div>
    
            </div>
    
          </div>
        </section>
        
        <section id="tutors" className="tutors section-bg-w">
          <div className="container" data-aos="fade-up">
    
            <div className="section-header">
              <h2>utisci</h2>
              <p>Šta drugi <span>kažu</span> o nama</p>
            </div>
    
            <div className="row gy-4">
    
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                <div className="tutor-member">
                  <div className="member-img">
                    <img src="/assets/images/tutors-1.webp" className="img-fluid" alt="Profesor"/>
                  </div>
                  <div className="member-info">
                    <h4>Ksenija Cmiljanić</h4>
                    <span>PROFESORKA MATEMATIKE</span>
                    <p>Platforma je pregledna i jednostavna za korišćenje. Učenici lako pronalaze termine, a ja imam potpunu kontrolu nad rasporedom.</p>
                  </div>
                </div>
              </div>
    
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                <div className="tutor-member">
                  <div className="member-img">
                    <img src="/assets/images/tutors-2.webp" className="img-fluid" alt="Profesor"/>
                  </div>
                  <div className="member-info">
                    <h4>Nemanja Lukić</h4>
                    <span>PROFESOR ENGLESKOG JEZIKA</span>
                    <p>Sajt mi je omogućio da organizujem časove bez stresa. Sve je automatizovano – prijave, obavještenja, čak i podsjetnici za učenike!</p>
                  </div>
                </div>
              </div>
    
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="300">
                <div className="tutor-member">
                  <div className="member-img">
                    <img src="/assets/images/tutors-3.webp" className="img-fluid" alt="Profesor"/>
                  </div>
                  <div className="member-info">
                    <h4>Jovana Petrović</h4>
                    <span>PROFESORKA HEMIJE</span>
                    <p>Zahvaljujući sajtu, moji časovi su postali dostupni većem broju učenika. Sistem za rezervaciju mi štedi mnogo vremena.</p>
                  </div>
                </div>
              </div>
    
            </div>
    
          </div>
        </section>
    
        <section id="register-tutor" className="contact section-bg">
          <div className="container" data-aos="fade-up">
        
    
              <RegistrationForm formType={"register-teacher"} onSuccess={handleFormSuccess} onFailure={handleFormFailure}/>
            
    
          </div>
        </section>
      </main>
    );
};

export default BecomeTutorPage;